import React, {Component} from "react"

import {Body} from "@irati/ui/src/Typography"
import {FormattedMessage} from "@irati/utils/lang"
import {ButtonRouterLink} from "@irati/ui/src/Link"

import {ADD_TEAM} from "../../../routes/routeConfig"

class EmptyTeams extends Component {
  render() {
    return (
      <>
        <Body marginBottom={1}>
          <FormattedMessage id="admin.reporting.emptyData.teams" />
        </Body>
        <ButtonRouterLink primary to={ADD_TEAM} id="admin_teams_buttonCreateTeam">
          <FormattedMessage id="admin.components.teamList.nameCountAndButton.buttonText" />
        </ButtonRouterLink>
      </>
    )
  }
}

export default EmptyTeams
